import { useCallback, useState } from 'react';

/**
 * View state of the 3D scene (colour mode, camera preset request, volume exploration filters, fence
 * display, terrain readiness), lifted out of the component that renders SubsurfaceViewer3D so the
 * /3d page's ribbon and the docked panel's controls drive the same props.
 */
export default function useViewer3dView() {
  const [colorMode, setColorMode] = useState('viridis');
  const [cameraPresetRequest, setCameraPresetRequest] = useState(null); // { id, seq }
  const onCameraPreset = useCallback((id) => {
    setCameraPresetRequest((prev) => ({ id, seq: (prev?.seq || 0) + 1 }));
  }, []);
  const [threshold, setThreshold] = useState([0, 1]);
  const [sliceAxis, setSliceAxis] = useState('none');
  const [slicePos, setSlicePos] = useState(0.5);
  const [sliceThickness, setSliceThickness] = useState(0.15);
  const [cropX, setCropX] = useState([0, 1]);
  const [cropZ, setCropZ] = useState([0, 1]);
  const [showVolumePanel, setShowVolumePanel] = useState(false);
  const [showFences, setShowFences] = useState(true);
  const [fenceOpacity, setFenceOpacity] = useState(0.95);
  // DEM terrain (docs/DEM_TERRAIN.md): true once TerrainMesh draws the draped fences
  const [terrainReady, setTerrainReady] = useState(false);

  const resetVolumeFilters = useCallback(() => {
    setThreshold([0, 1]);
    setSliceAxis('none');
    setSlicePos(0.5);
    setSliceThickness(0.15);
    setCropX([0, 1]);
    setCropZ([0, 1]);
  }, []);

  return {
    colorMode, setColorMode, cameraPresetRequest, onCameraPreset,
    threshold, setThreshold, sliceAxis, setSliceAxis, slicePos, setSlicePos, sliceThickness, setSliceThickness,
    cropX, setCropX, cropZ, setCropZ, showVolumePanel, setShowVolumePanel,
    showFences, setShowFences, fenceOpacity, setFenceOpacity, terrainReady, setTerrainReady,
    resetVolumeFilters,
  };
}
